import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyDgY17yHZCged4f8_gaMiqPghVhbs_i97s",
    authDomain: "hirelanes.firebaseapp.com",
    projectId: "hirelanes",
    storageBucket: "hirelanes.appspot.com",
    messagingSenderId: "813315536218",
    appId: "1:813315536218:web:1d324c6194efd92424af63"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();

  export { db , auth };